import MessageListingPreview from './MessageListingPreview.component';

export default MessageListingPreview;